// @flow
/**
 * THIS IS THE ENTRY POINT FOR THE CLIENT, JUST LIKE server.js IS THE ENTRY POINT FOR THE SERVER.
 */
import 'anue-fe-sdk/web-preset';
// import 'anue-fe-sdk/preset-init';
import 'intersection-observer';
import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import history from 'utils/history';
import { getInstance } from './hooks/auth';
// import { syncHistoryWithStore } from 'react-router-redux';

import createStore from './redux/create';
// import apiClientFactory from './helpers/apiClientFactory';
import { initialAnalytics, initialGTM } from './utils/analytics';
import './helpers/serviceWorker';
// import { connectToHistory } from './utils/analyticsOnHistory';
// import { whyDidYouUpdate } from 'why-did-you-update';
import Routes from './routes';
import './index.scss';

const isServer = typeof window === 'undefined';

// const APP_NAME = 'stock';
// const PROJECT_NAME = 'fe-stock';

// Google analytics and piwik initial
initialAnalytics();
// Initialize GTM
initialGTM();

if (console && console.log) {
  console.log(
    '%c                ',
    ';background-repeat: no-repeat; background: url(data:image/svg+xml;base64,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) left no-repeat; padding:4px;'
  );
}

export const store = createStore(history, {
  env: {
    desktopBaseUrl: 'http://news.cnyes.com',
    now: Date.now(),
  },
});

const component = (
  <Router history={history.getHistory()} initialEntries={['/market/TWS:TSE01:INDEX']}>
    <Routes />
  </Router>
);

if (process.env.NODE_ENV !== 'production' && !isServer) {
  window.React = React; // enable debugger
}

// eslint-disable-next-line
let content = null;

if (!isServer && __DEVELOPMENT__ && __DEVTOOLS__ && !window.devToolsExtension) {
  content = (
    <Provider store={store} key="provider">
      <div>{component}</div>
    </Provider>
  );
} else {
  content = (
    <Provider store={store} key="provider">
      {component}
    </Provider>
  );
}

// perform render in browser environment
if (!isServer) {
  getInstance()
    .consume()
    .then(() => {
      ReactDOM.render(content, document.getElementById('root'));
    });
}

export default content;
